import SectionHeading from './SectionHeading';
import { timeline } from '@/mocks/gossipData';

const toneMap: Record<string, string> = {
  话题萌芽: 'bg-secondary-100 text-secondary-800',
  热度爬升: 'bg-primary-100 text-primary-800',
  讨论高峰: 'bg-accent-100 text-accent-800',
  反转求证: 'bg-primary-100 text-primary-700',
  物料潮: 'bg-secondary-100 text-secondary-800',
  热度顶峰: 'bg-accent-500 text-background-50',
  长尾发酵: 'bg-secondary-100 text-secondary-800',
};

export default function TimeLine() {
  return (
    <section id="timeline" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          kicker="瓜田时间线"
          title="昨日瓜田大事件"
          accent="按点速览"
          desc="从早间的第一口瓜，到深夜的二创长尾，把昨日的讨论热点按时间顺序串成一条清晰的线。"
        />

        <div className="relative mt-10 md:mt-12">
          {/* rail */}
          <div className="absolute left-[5px] top-0 h-full w-px bg-secondary-300 md:left-[164px]" aria-hidden />
          <ol className="flex flex-col gap-5">
            {timeline.map((item, i) => {
              const tone = toneMap[item.tone] ?? 'bg-secondary-100 text-secondary-800';
              return (
                <li key={i} className="relative pl-8 md:grid md:grid-cols-[150px_1fr] md:gap-6 md:pl-0">
                  <span
                    className={`absolute left-0 top-5 flex h-[11px] w-[11px] rounded-full ring-4 ring-background-100 ${
                      i === timeline.length - 1 ? 'bg-accent-500' : 'bg-primary-500'
                    }`}
                    aria-hidden
                  />
                  <div className="pt-1">
                    <span className="font-heading text-sm font-bold text-foreground-800 md:inline-block md:w-full md:text-right">
                      {item.slot}
                    </span>
                  </div>
                  <div className="mt-2 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:mt-0 md:p-5">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                      <span className={`whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${tone}`}>{item.tone}</span>
                    </div>
                    <p className="mt-2 text-sm leading-6 text-foreground-600">{item.detail}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}